 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		279: 0,
 		277: 0,
 		278: 0,
 		281: 0,
 		328: 0,
 		329: 0,
 		335: 0,
 		336: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","215":"AddClosedAlertIDUseCase","216":"CreateDeviceUseCase","217":"CreateDomestikaFollowUseCase","218":"CreateJWTUserUseCase","219":"CreateUserLiveSessionUseCase","220":"CurrentUserUseCase","221":"CurrentWithoutRelationshipsUserUseCase","222":"DeleteDeviceUseCase","223":"DeleteFollowUseCase","224":"ENV_CONFIG1","225":"ENV_CONFIG4","226":"ENV_CONFIG5","227":"ENV_CONFIG6","228":"ENV_CONFIG7","229":"FinishUserLiveSessionUseCase","230":"GetAccessTokenUserUseCase","231":"GetAdvanceGDPRStatusUserUseCase","232":"GetAllBlogUseCase","233":"GetAreasCourseUseCase","234":"GetCartCourseUseCase","235":"GetCategoriesCourseUseCase","236":"GetCourseUseCase","237":"GetFinalProjectVideoByCourseIDCourseUseCase","238":"GetGDPRStatusUserUseCase","239":"GetListLiveFeedbackQuestionUseCase","240":"GetListLiveSessionUseCase","241":"GetListLiveStreamUseCase","242":"GetLiveChannelUseCase","243":"GetLiveSessionUseCase","244":"GetOrganizationUseCase","245":"GetPlusPromotionUseCase","246":"GetPostContentBlogUseCase","247":"GetPromotionCodeAlertUseCase","248":"GetPromotionUseCase","249":"GetPubnubCredentialsUseCase","250":"GetSessionDataUserUseCase","251":"GetSimpleUserUseCase","252":"GetSoftwaresCourseUseCase","253":"GetUserAlertUseCase","254":"GetVideoProgressListCourseUseCase","255":"GetVideoSpeedUserUseCase","256":"GetVideoVolumeUserUseCase","257":"LogoutUserUseCase","258":"PathToRegexp","259":"RefreshAccessTokenUserUseCase","260":"RemoveAccessTokenUserUseCase","261":"SearchCourseUseCase","262":"SendHeaderTrackingUseCase","263":"SendLiveFeedbackAnswersUseCase","264":"SendPlayerTrackingUseCase","265":"SendTrackingUseCase","266":"SendVideoProgressCourseUseCase","267":"SetAdvanceGDPRStatusUserUseCase","268":"SetGDPRStatusUserUseCase","269":"SetVideoSpeedUserUseCase","270":"SetVideoVolumeUserUseCase","271":"UpdateLanguageUserUseCase","272":"UpdateLiveSessionUseCase","273":"UpdateVideoAudioAndSubtitlesCourseUseCase","274":"UpdateVideoProgressCourseUseCase","275":"ViewPageTrackingUseCase","334":"vendors~AddClosedAlertIDUseCase","335":"vendors~AlgoliaSearch","336":"vendors~AmplitudeJS","337":"vendors~SearchCourseUseCase","338":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"6dfe29bfe68a6414ddfe","1":"ba037fca6860569da957","2":"ee3e90490a9c18cc9faa","3":"c5755e9ad7e05ce1c86e","4":"eb1990ca62e2200c9933","5":"5d1ff3fa3cf784c0d043","215":"20094ce1e21dda5dd77a","216":"7978776c27b867f04628","217":"771a18fdf18a9d604d0f","218":"1a55a768ec1e7f4599c0","219":"778562cd84970e92722a","220":"b0210b1760cff1645e9b","221":"983b777ccd976c00df30","222":"bda6978a10b3bd1a490d","223":"34a88f32b3c07d1530e8","224":"2c36799f7b9f001c0dbf","225":"8d2eccbb1372980667e3","226":"f86244ec2820ff996eed","227":"807351af89bbff2ff68a","228":"58ceb03b332eebab3cf4","229":"1a36ddec7234694cdc03","230":"1d92f5644ada8505e4fe","231":"9c6004ae755f7cdb8116","232":"a2652290e1f28c77d34a","233":"c9152c6a909d6a0a8edb","234":"e24e5f836361e12a9f3e","235":"67a1c5476e0e3f3901ca","236":"58c994512b876902a557","237":"92792143ec52a49d78b2","238":"0dc385dab8f81954f78d","239":"44aa53b6ca13446644fd","240":"428e76102b17efd25920","241":"58d5f660b8a0107655b8","242":"d37329108f53194769c1","243":"71e0e7cc69a8431831b7","244":"e6d379e116e702a31ebe","245":"53e85213ca6c1ceea3c5","246":"67d3d8d9397b0a7f2fba","247":"7564e27c90a23c23f178","248":"8d4e09c87450926afd97","249":"f476ed0032c5b1731a0a","250":"15a720eedf567bdd6b8c","251":"d46467572b38e020ff8d","252":"89ea5c19b41b439d0d8a","253":"274753fd0a385d09ed25","254":"9a3c1e46c5bba3265f5d","255":"a1d53316b0781ada279b","256":"a8d8015d5a32fd4c2337","257":"9e67c6ea0a3e2ec922bd","258":"7d67541a9fa4f4659667","259":"580e98da597552d8e018","260":"ba18e43be5534e1bf305","261":"fba002a469910cd9c72b","262":"fa409c54aae51ebc39c9","263":"214fc00c07d0a9ba5c86","264":"b8967d270739397b22e4","265":"3d5c1716d2a7b2fe936d","266":"ba8b9c0184bd86da830a","267":"fba19dfdd5b6423eeb1b","268":"f3294e1363231b000d8e","269":"90f63243c3708929671d","270":"8750d674dbe7cb3bda2f","271":"e584786b626e91ccf28d","272":"d55a91c39e7c1b037b8a","273":"ad0ea147f02a1a3f2b93","274":"c5dafccaaa84e4bf1c61","275":"dd1942a176e7a127ed8b","334":"5d9fe9e5314f1f1df830","335":"bc2108a5845fd5efb2f0","336":"303abf7a5b5681ad2bfa","337":"c70b5ead5b58c6422662","338":"4be80bc3324643c477d4","411":"7da8253a26753feb8389","629":"af06816e6fb2fefd879c","630":"35119bebffa42eb88dda"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2185);
